<template>
	<div v-if='showLuckyModal'>
		<div class="lucky-modal" v-if='type=="modal"'>
			<div class="poster-box" v-if='showType == 1 && luckyModalValue.Pic'>
				<div class="poster">
					<div id="capturePoster">
						<img class='poster-img' :src="luckyModalValue.Pic" alt="">
						<img class='head-img' :src="userInfo.value.head_image_url || 'https://cdn.dohwg.cn/images/universal/normalhead.png'" alt="">
						<div class="username">{{userInfo.value.binding.name}}</div>
						<div class="minicode-box">
							<img class='minicode'  :src='"data:image/png;base64," + wxacode'/>
							<!-- <div class="minicode-text">长按识别二维码</div> -->
							<!-- <div class="minicode-text">一起为爱加油</div> -->
						</div>
					</div>
					<div class="close" @click='showType = 2'>
						<Icon color='#e6729f' size='30' type="md-close-circle" />
					</div>
				</div>
				<div class="btns">
					<div class="btn" @click='download'>保存图片</div>
					<div class="btn" @click='goLuck'>去抽奖</div>
				</div>
				<canvas  id="myCanvas" canvas-id="myCanvas" :style="{width: '900px;',height: '1200px;',position:'absolute',left:'750rpx'}"></canvas>
			</div>
			<div class="luck-modal-content" v-else>
				<div v-html='luckyModalValue.Content'></div>
				<Button @click='goLuck' :class='timeout() ? "disabled-button":"button"'>{{luckyModalValue.ExtStr1}}</Button>
				<div class="close" @click='showLuckyModal = false'>
					<Icon color='#e6729f' size='30' type="md-close-circle" />
				</div>
			</div>
		</div>
		<div class="go-button" v-else-if='type=="button"'>
			<div v-html='luckyModalValue.Content'></div>
			<Button @click='goLuck' :class='timeout() ? "disabled-button":"button"'>{{luckyModalValue.ExtStr1}}</Button>
		</div>
	</div>
</template>

<script>
	const SecretKey = '7fe3890fce12fb4836ab25evd3421eb8ceea'
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex'
	import util from "@/config/util";
	export default {
		data() {
			return {
				showLuckyModal:false,
				luckyModalValue:{},
				wxacode:'',
				showType:1,
				dataURL:'',
			}
		},
		props:{
			orderStatus:{
				type:Object,
				default:()=>{}
			},
			type:{
				type:String,
				default:'modal',
			},
			luckyDraw:{
				type:Object,
				default:()=>{}
			},
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({
				sysConfig: (state) => state.common.sysConfig,
				userInfo: state => state.common.wechatUserInfo,
			}),
			...mapGetters([
				'getVipNo','getAccessToken',
			]),
			nowDate: function() {
				let Config = this.sysConfig.value;
				if (Config.now_time) {
					return util.formatDate.dateFromStr(Config.now_time);
				}
				return new Date();
			},
		},
		methods: {
			...mapActions([
				'getwxacodeAction',
			]),
			async initData(){
				if (this.type == 'modal') {
					let url = `pages/home/home?pcno=${this.getVipNo}`
					this.wxacode = await this.getwxacodeAction(url)
				}
				let payTime = util.formatDate.dateFromStr(this.orderStatus.Paytime || this.orderStatus.PayEndTime),validFrom = util.formatDate.dateFromStr(this.luckyDraw.ValidFrom)
				if (this.timeComparison(this.luckyDraw.ValidFrom,this.luckyDraw.ValidTo) && payTime >= validFrom) {
					this.luckyModalValue = this.luckyDraw
					this.showLuckyModal = true
				}
			},
			timeout(){
				let payTimeStr = this.orderStatus.Paytime || this.orderStatus.PayEndTime
				if (payTimeStr) {
					let payTime = util.formatDate.dateFromStr(payTimeStr);
					var now = new Date();
					return now - payTime > 900000
				}
				return true
			},
			timeComparison(str, str1) {
				var valid_from = !str ? null : util.formatDate.dateFromStr(str);
				var valid_to = !str1 ? null : util.formatDate.dateFromStr(str1);
				var now = new Date();
				return (
					(valid_from <= now || !valid_from) &&
					(valid_to >= now || !valid_to)
				);
			},
			goLuck() {
				if (this.timeout()) {
					this.$Toast.show('很遗憾，您本次抽奖资格已逾期。')
					return
				} else if (!this.timeComparison(this.luckyModalValue.ValidFrom,this.luckyModalValue.ValidTo)) {
					this.$Toast.show('本次抽奖活动已结束，感谢您的参与。')
					return
				}
				let {OrderNo,VipNo,forVipNo,PValue} = this.orderStatus
				let name = this.userInfo?.value?.binding?.name,
					returnurl = encodeURIComponent(`${location.origin}${location.pathname}#/order/orders`),
					timestamp = this.nowDate.getTime(),
					payTime = util.formatDate.dateFromStr(this.orderStatus.Paytime || this.orderStatus.PayEndTime).getTime();
				// 密钥+客户编号+订单号+时间戳
				let sign = `${SecretKey}${forVipNo || VipNo}${OrderNo}${timestamp}`.MD5(32)
				let url = `${this.luckyModalValue.Link}&pcno=${forVipNo || VipNo}&orderno=${OrderNo}&orderpv=${PValue}&name=${name}&payTime=${payTime}&platform=WebSite&returnurl=${returnurl}&timestamp=${timestamp}&sign=${sign}&uid=${this.getAccessToken}`
				location = url
			},
			async downloadIamge(imgsrc, name) {
				var canvas = document.createElement("canvas");
				canvas.width = 900;
				canvas.height = 1200;
				var context = canvas.getContext("2d");
				let img = await this.$loadImage(this.luckyModalValue.Pic)
				context.drawImage(img,0,0,900,1200)
				context.save()
				// if(this.userInfo.value.head_image_url) {
					context.beginPath()
					context.arc(160,515, 65, 0, 2 * Math.PI)
					context.fillStyle = '#EEEEEE'
					context.fill()
					context.clip()
					let img2 = await this.$loadImage(this.userInfo.value.head_image_url || 'https://cdn.dohwg.cn/images/universal/normalhead.png')
					context.drawImage(img2,95,450,130,130)
			        context.restore()
				// }

				context.font = 'normal normal 30px sans-serif'
				context.textAlign = 'left'
				context.fillStyle = '#BD8BCA'
				context.fillText(this.userInfo.value.binding.name, 245, 565)
				let img3 = new Image() 
				img3.src = "data:image/png;base64," + this.wxacode
				context.drawImage(img3,710,1010,130,130)

				// context.textAlign = 'center'
				// context.font = 'normal normal 12px sans-serif'
				// context.fillStyle = '#333'
				// context.fillText('长按识别二维码', 793, 1123)
				// context.fillText('一起为爱加油', 793, 1137)
				var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

				var a = document.createElement("a"); // 生成一个a元素
				var event = new MouseEvent("click"); // 创建一个单击事件
				a.download = name || "photo"; // 设置图片名称
				a.href = url; // 将生成的URL设置为a.href属性
				a.dispatchEvent(event); // 触发a的单击事件
			},
			async download() {
				this.downloadIamge(this.dataURL,'下载')
			},
		},
	}
</script>

<style lang='scss' scoped>
	.lucky-modal {
		position:fixed;
		z-index:9999;
		left: 0;
		top: 0;
		width:100vw;
		height:100vh;
		background-color:rgba(0,0,0,0.4);
		display:flex;
		flex-direction:column;
		align-items: center;
		justify-content: center;
		.luck-modal-content {
			box-shadow:3px 6px 20px 8px rgba(0,0,0,0.2);
			width:400px;
			background-color:white;
			border-radius:10px;
			padding:30px 0;
			display:flex;
			align-items:center;
			flex-direction: column;
			border:1px solid #e6729f;
			position:relative;
		}
		.button {
			background-color:#e6729f;
			border-color:#e6729f;
			width:120px;
			color:white;
			margin-top: 30px;
			border-radius:20px;
		}
		.disabled-button {
			background-color:#eee;
			border-color:#eee;
			min-width:120px;
			color:#aaa;
			margin-top: 30px;
			border-radius:20px;
		}
		.close {
			width:30px;
			height:30px;
			background-color:white;
			border-radius: 30px;
			margin-top: 40px;
			display:flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: -50px;
			right: -10px;
			cursor: pointer;
		}
	}
	.go-button {
		display:flex;
		align-items: center;
		flex-direction: column;
		.button {
			background-color:#e6729f;
			border-color:#e6729f;
			min-width:120px;
			color:white;
			margin-top: 30px;
			border-radius:20px;
		}
		.disabled-button {
			background-color:#eee;
			border-color:#eee;
			min-width:120px;
			color:#aaa;
			margin-top: 30px;
			border-radius:20px;
		}
	}
	.poster {
		position:relative;
		.poster-img {
			width:360px;
			height:480px;
		}
		.head-img {
			position:absolute;
			top: 180px;
			left:36px;
			width:57.6px;
			height:57.6px;
			border-radius: 28.8px;
		}
		.username {
			position:absolute;
			top: 213px;
			left:99px;
			width:120px;
			height:18px;
			color:#BD8BCA;
		}
		.minicode-box {
			position:absolute;
			bottom:30px;
			right:25px;
		    display: flex;
		    flex-direction: column;
		    align-items: center;
		    // transform: scale(0.5) translate(50px, 60px);
			.minicode {
				width:50px;
				height:50px;
			}
			.minicode-text {
				font-size: 14.4px;
			}
		}
	}
	.btns {
		margin: 15px;
		display:flex;
		margin-bottom:0;
		align-items:center;
		justify-content:space-between;
		.btn {
			background-color:white;
			border:1px solid #BD8BCA;
			color:#BD8BCA;
			width:150px;
			text-align:center;
			padding:3px 0;
			cursor: pointer;
		}
	}
</style>
